// SpinalCordIndependenceSection.js
import React from 'react';
import { Phone } from 'lucide-react';
import spinalCordIndependenceImage from '../assets/spinal-cord-independence-image.jpg';

const SpinalCordIndependenceSection = () => {
  return (
    <section className="py-16 md:py-24 bg-bnCream">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

          {/* Left Content */}
          <div>
            <p className="text-bnAccent text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-5">
              Spinal Cord Injury Care
            </p>
            <h2 className="font-display font-light text-bnInk leading-[1.1] text-3xl md:text-4xl lg:text-5xl mb-6">
              Spinal Cord Injury Care That Fosters Independence
            </h2>

            <div className="space-y-4 text-bnBody text-base leading-relaxed mb-10 max-w-lg">
              <p>
                At B &amp; N Enterprise, we understand that spinal cord injuries bring unique challenges that call for attentive, adaptive, and consistent care. Our goal is to help the people we support rebuild confidence, mobility, and independence in the comfort of their own homes. Each care plan is thoughtfully designed around individual needs, whether that means help with movement, personal care, or emotional encouragement throughout recovery.
              </p>
              <p>
                Spinal cord injury care is about more than physical support, it is about empowering people to live with dignity and purpose every day. Our carers provide reliable help with exercises, daily routines, and adaptive activities that promote progress and stability. We also work closely with families, offering education, reassurance, and peace of mind as their loved one navigates the road to recovery.
              </p>
            </div>

            <a
              href="tel:+61480804640"
              className="inline-flex items-center gap-2 bg-bnAccent hover:bg-bnAccentDark text-white font-medium text-sm px-7 py-3.5 rounded-full transition-colors"
            >
              <Phone size={18} />
              Call: +61 480 804 640
            </a>
          </div>

          {/* Right Image */}
          <div className="relative">
            <img
              src={spinalCordIndependenceImage}
              alt="A carer with a woman in a wheelchair outdoors"
              className="w-full h-[420px] lg:h-[560px] object-cover rounded-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpinalCordIndependenceSection;
